<template>
    <div class="a-loader-ac">
        <svg
            class="loader__spinner"
            viewBox="0 0 50 50"
        >
            <circle
                class="loader__spinner-path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="5"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'ALoaderAc'
};
</script>

<style lang="scss" src="./a-loader-ac.scss" />
